import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Check, Shield, Users, Heart, Star, ArrowRight } from 'lucide-react';

const tiers = [
  {
        name: 'Solo',
        price: '9.99',
        description: 'Perfect for getting started',
        popular: false,
        features: [
                '1 senior profile',
                'Smart reminders & scheduling',
                'Mood & wellness tracking',
                'CareChat messaging',
                '"I\'m okay" daily check-in',
                '14-day free trial',
              ],
        icon: Heart,
  },
  {
        name: 'Family',
        price: '19.99',
        description: 'Most popular for families',
        popular: true,
        features: [
                'Everything in Solo',
                'Family sharing (up to 5 members)',
                'SOS alerts & notifications',
                'Care Timeline daily view',
                'Missed reminder family alerts',
                '14-day free trial',
              ],
        icon: Users,
  },
  {
        name: 'Peace of Mind',
        price: '34.99',
        description: 'Complete care coverage',
        popular: false,
        features: [
                'Everything in Family',
                'Unlimited family members',
                'Full AI companion access',
                'HCA Resource Centre',
                'Priority support',
                '14-day free trial',
              ],
        icon: Shield,
  },
  ];

export const PricingPage = () => {
    const navigate = useNavigate();

    return (
          <div
                  style={{
                            minHeight: '100vh',
                            background: 'linear-gradient(180deg, #0F172A 0%, #1a1a2e 50%, #0F172A 100%)',
                            color: '#F1F5F9',
                            fontFamily: 'system-ui, -apple-system, sans-serif',
                  }}
                >
            {/* Header */}
                <header
                          style={{
                                      padding: '20px 24px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'space-between',
                                      maxWidth: '1200px',
                                      margin: '0 auto',
                          }}
                        >
                        <div
                                    style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}
                                    onClick={() => navigate('/')}
                                  >
                                  <div
                                                style={{
                                                                width: '36px',
                                                                height: '36px',
                                                                borderRadius: '10px',
                                                                background: 'linear-gradient(135deg, #8B5A2B, #D4A574)',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                fontSize: '18px',
                                                                fontWeight: '800',
                                                                color: '#fff',
                                                }}
                                              >
                                              D
                                  </div>
                                  <span style={{ fontSize: '20px', fontWeight: '700', color: '#D4A574' }}>DIPPS</span>
                        </div>
                        <button
                                    onClick={() => navigate('/sign-in')}
                                    style={{
                                                  padding: '10px 24px',
                                                  borderRadius: '12px',
                                                  border: '1px solid #334155',
                                                  background: 'transparent',
                                                  color: '#94A3B8',
                                                  fontSize: '14px',
                                                  fontWeight: '600',
                                                  cursor: 'pointer',
                                    }}
                                  >
                                  Sign In
                        </button>
                </header>
          
            {/* Hero */}
                <section
                          style={{
                                      textAlign: 'center',
                                      padding: '60px 24px 40px',
                                      maxWidth: '800px',
                                      margin: '0 auto',
                          }}
                        >
                        <h1
                                    style={{
                                                  fontSize: 'clamp(28px, 5vw, 48px)',
                                                  fontWeight: '800',
                                                  lineHeight: '1.2',
                                                  marginBottom: '16px',
                                                  background: 'linear-gradient(135deg, #D4A574, #8B5A2B)',
                                                  WebkitBackgroundClip: 'text',
                                                  WebkitTextFillColor: 'transparent',
                                    }}
                                  >
                                  Care that never sleeps.
                                  <br />
                                  Peace of mind for the whole family.
                        </h1>
                        <p
                                    style={{
                                                  fontSize: 'clamp(16px, 2.5vw, 20px)',
                                                  color: '#94A3B8',
                                                  marginBottom: '8px',
                                    }}
                                  >
                                  14-day free trial. No credit card required.
                        </p>
                </section>
          
            {/* Pricing Cards */}
                <section
                          style={{
                                      display: 'flex',
                                      flexWrap: 'wrap',
                                      gap: '24px',
                                      justifyContent: 'center',
                                      padding: '0 24px 60px',
                                      maxWidth: '1100px',
                                      margin: '0 auto',
                          }}
                        >
                  {tiers.map((tier) => {
                                    const Icon = tier.icon;
                                    return (
                                                  <div
                                                                  key={tier.name}
                                                                  style={{
                                                                                    flex: '1 1 300px',
                                                                                    maxWidth: '360px',
                                                                                    background: tier.popular
                                                                                                        ? 'linear-gradient(180deg, #1E293B 0%, #1a2234 100%)'
                                                                                                        : '#1E293B',
                                                                                    borderRadius: '24px',
                                                                                    padding: '32px 28px',
                                                                                    border: tier.popular
                                                                                                        ? '2px solid #D4A574'
                                                                                                        : '1px solid #334155',
                                                                                    position: 'relative',
                                                                                    boxShadow: tier.popular
                                                                                                        ? '0 0 40px rgba(212, 165, 116, 0.15), 0 20px 60px rgba(0,0,0,0.3)'
                                                                                                        : '0 10px 40px rgba(0,0,0,0.2)',
                                                                                    transform: tier.popular ? 'scale(1.03)' : 'none',
                                                                                    display: 'flex',
                                                                                    flexDirection: 'column' as const,
                                                                  }}
                                                                >
                                                    {tier.popular && (
                                                                                  <div
                                                                                                      style={{
                                                                                                                            position: 'absolute',
                                                                                                                            top: '-14px',
                                                                                                                            left: '50%',
                                                                                                                            transform: 'translateX(-50%)',
                                                                                                                            background: 'linear-gradient(135deg, #D4A574, #8B5A2B)',
                                                                                                                            color: '#fff',
                                                                                                                            padding: '6px 20px',
                                                                                                                            borderRadius: '20px',
                                                                                                                            fontSize: '13px',
                                                                                                                            fontWeight: '700',
                                                                                                                            display: 'flex',
                                                                                                                            alignItems: 'center',
                                                                                                                            gap: '4px',
                                                                                                                            whiteSpace: 'nowrap' as const,
                                                                                                        }}
                                                                                                    >
                                                                                                    <Star size={14} fill="#fff" /> Most Popular
                                                                                  </div>
                                                                )}
                                                  
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                                                                                <div
                                                                                                    style={{
                                                                                                                          width: '44px',
                                                                                                                          height: '44px',
                                                                                                                          borderRadius: '14px',
                                                                                                                          background: tier.popular
                                                                                                                                                  ? 'linear-gradient(135deg, #D4A574, #8B5A2B)'
                                                                                                                                                  : 'rgba(212, 165, 116, 0.1)',
                                                                                                                          display: 'flex',
                                                                                                                          alignItems: 'center',
                                                                                                                          justifyContent: 'center',
                                                                                                      }}
                                                                                                  >
                                                                                                  <Icon size={22} color={tier.popular ? '#fff' : '#D4A574'} />
                                                                                </div>
                                                                                <div>
                                                                                                  <h3 style={{ fontSize: '20px', fontWeight: '700', margin: 0 }}>{tier.name}</h3>
                                                                                                  <p style={{ fontSize: '13px', color: '#64748B', margin: 0 }}>{tier.description}</p>
                                                                                </div>
                                                                </div>
                                                  
                                                                <div style={{ marginBottom: '24px' }}>
                                                                                <span style={{ fontSize: '42px', fontWeight: '800' }}>${tier.price}</span>
                                                                                <span style={{ fontSize: '16px', color: '#64748B' }}>/mo</span>
                                                                                <p style={{ fontSize: '12px', color: '#475569', margin: '4px 0 0' }}>+ applicable taxes</p>
                                                                </div>
                                                  
                                                                <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 28px', flex: 1 }}>
                                                                  {tier.features.map((feature) => (
                                                                                    <li
                                                                                                          key={feature}
                                                                                                          style={{
                                                                                                                                  display: 'flex',
                                                                                                                                  alignItems: 'center',
                                                                                                                                  gap: '10px',
                                                                                                                                  padding: '8px 0',
                                                                                                                                  fontSize: '14px',
                                                                                                                                  color: '#CBD5E1',
                                                                                                                                  borderBottom: '1px solid rgba(51, 65, 85, 0.5)',
                                                                                                            }}
                                                                                                        >
                                                                                                        <Check size={16} color="#D4A574" style={{ flexShrink: 0 }} />
                                                                                      {feature}
                                                                                      </li>
                                                                                  ))}
                                                                </ul>
                                                  
                                                                <button
                                                                                  onClick={() => navigate('/register')}
                                                                                  style={{
                                                                                                      width: '100%',
                                                                                                      padding: '16px',
                                                                                                      borderRadius: '14px',
                                                                                                      border: 'none',
                                                                                                      fontSize: '16px',
                                                                                                      fontWeight: '700',
                                                                                                      cursor: 'pointer',
                                                                                                      display: 'flex',
                                                                                                      alignItems: 'center',
                                                                                                      justifyContent: 'center',
                                                                                                      gap: '8px',
                                                                                                      background: tier.popular
                                                                                                                            ? 'linear-gradient(135deg, #D4A574, #8B5A2B)'
                                                                                                                            : 'rgba(212, 165, 116, 0.1)',
                                                                                                      color: tier.popular ? '#fff' : '#D4A574',
                                                                                                      transition: 'all 0.2s',
                                                                                  }}
                                                                                >
                                                                                Start Free Trial <ArrowRight size={18} />
                                                                </button>
                                                  </div>
                                                );
                        })}
                </section>
          
            {/* Footer note */}
                <div
                          style={{
                                      textAlign: 'center',
                                      padding: '0 24px 60px',
                                      color: '#64748B',
                                      fontSize: '14px',
                          }}
                        >
                        <p style={{ margin: '0 0 8px' }}>
                                  Seniors always free. Cancel anytime. No contracts.
                        </p>
                        <p style={{ margin: 0, fontSize: '12px' }}>
                                  All prices in CAD. 14-day free trial on all plans.
                        </p>
                </div>
          </div>
        );
};


  export default PricingPage;
